import { EMPLOYER_TOGGLABLE_PERMISSIONS } from '../constants/project-togglable-permissions';

export const returnTogglableDefaultBusinessPermissions = () => {
  let defaults = {};

  EMPLOYER_TOGGLABLE_PERMISSIONS.forEach((permission) => {
    defaults[permission] = false;
  });

  return defaults;
};
